import React from 'react';
import OrderListPage from './OrderListPage';

interface IProps {
  handleModalOpen: (data: any) => void;
  rowDetails: any;
  setRowDetails: any;
}

const NewOrders = (props: IProps) => (
  <OrderListPage
    section="New Orders"
    emptyMessage="No new orders right now."
    {...props}
  />
);

export default NewOrders;
